import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import Home from "./pages/Home";
import Category from "./pages/Category";
import ProductDetail from "./pages/ProductDetail";
import Maison from "./pages/Maison";
import Contact from "./pages/Contact";
import CartPage from "./pages/Cart";
import WishlistPage from "./pages/Wishlist";
import SearchPage from "./pages/Search";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Account from "./pages/Account";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import "./App.css";

const TOAST_OPTIONS = {
  style: {
    background: "#1A1311",
    border: "1px solid rgba(184,115,51,0.3)",
    color: "#F4EBE1",
  },
};

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <WishlistProvider>
            <ScrollToTop />
            <Header />
            <CartDrawer />
            <main className="min-h-screen bg-capra-night">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/new-collection" element={<Category key="new-collection" slug="new-collection" />} />
                <Route path="/men" element={<Category key="men" slug="men" />} />
                <Route path="/women" element={<Category key="women" slug="women" />} />
                <Route path="/tracksuits" element={<Category key="tracksuits" slug="tracksuits" />} />
                <Route path="/leather-goods" element={<Category key="leather-goods" slug="leather-goods" />} />
                <Route path="/accessories" element={<Category key="accessories" slug="accessories" />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/maison" element={<Maison />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/wishlist" element={<WishlistPage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/account" element={<Account />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="bottom-right" toastOptions={TOAST_OPTIONS} />
          </WishlistProvider>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
